import { jsx as t, jsxs as s } from "react/jsx-runtime";
import "react";
import { AirDateSegment as f } from "./AirDateSegment.js";
import { ImageCard as l } from "../../ImageCard/ImageCard.js";
import { StringList as e } from "../../StringList/StringList.js";
import { Concat as g } from "../../Concat/Concat.js";
import { classes as C } from "../../../utils/helpers.js";
function j({ scheduleItem: i, styles: r, handleClicks: a, strListArr: n, determineCTA: p }) {
  var o;
  const m = [
    `<div>${i.program_synopsis}</div>`,
    /* @__PURE__ */ t(e, { list: n, separatorType: "pipe" })
  ];
  return /* @__PURE__ */ s("li", { className: C([r["schedule-list__item"], "schedule-list__item"]), children: [
    /* @__PURE__ */ t(f, { scheduleItem: i, styles: r }),
    /* @__PURE__ */ t(
      l,
      {
        id: i.id,
        image: {
          url: ((o = i == null ? void 0 : i.content) == null ? void 0 : o.image) ?? "",
          altText: "",
          aspectRatio: 543 / 305
        },
        title: i.program,
        content: /* @__PURE__ */ t(g, { list: m }),
        cta: p(i),
        clampContentLines: !0,
        numberOfLinesToClamp: 5,
        displayInline: !0,
        handleClicks: a
      }
    )
  ] }, `schedule-list-${i.id}`);
}
export {
  j as MovieItem,
  j as default
};
